import VMasker from 'vanilla-masker';
import removerAcentuacao from './removerAcentuacao';

export default function convertBuscaEcResponse(data) {
  const ddd = data.ddd.length === 3 ? data.ddd.substr(1) : data.ddd;
  const telefone = `${ddd}${data.telefone}`;
  const pattern = telefone.length >= 11 ? '(99) 99999-9999' : '(99) 9999-9999';
  let { statusEC } = data;
  if (String(data.statusEC).toLowerCase() === 'ativo') {
    if (data.produtosIndicacaoEC.length === 0) {
      statusEC = 'INATIVO';
    }
  }

  const cidade = removerAcentuacao(String(data.cidade).toUpperCase());

  return {
    ...data,
    statusEC,
    endereco: data.logradouro,
    cidade,
    telefone: VMasker.toPattern(telefone, pattern),
    produtosIndicacaoEC: data.produtosIndicacaoEC.map(prod =>
      Number(prod.codigo),
    ),
  };
}
